import { SinglePaymentHeaderComponent } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodHeader/components/SinglePaymentHeaderComponent';
import { withPaymentMethodCardWrapper } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodWrapper';
import { SinglePaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/SinglePaymentMethod';

interface A2APaymentMethodCardProps {
  paymentMethodEntity: SinglePaymentMethod;
}

export const A2APaymentMethodCard = ({ paymentMethodEntity }: A2APaymentMethodCardProps) => {
  return <SinglePaymentHeaderComponent paymentMethodEntity={paymentMethodEntity} />;
};

export const A2APaymentMethodCardWithWrapper = withPaymentMethodCardWrapper(A2APaymentMethodCard);
